import { InputRadioComponent } from './input-radio.component';

export default angular
  .module('sfMobile.components.input-radio', [])
  .component('sfInputRadio', InputRadioComponent).name;
